import {useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {Link, useNavigate} from 'react-router-dom'
import {toast} from 'react-toastify'
import {createWorker, reset} from '../features/workers/workerSlice'
import Spinner from '../components/Spinner'
import { useEffect } from 'react'

function NewWorker(){
    
   
    const {isLoading, isError, isSuccess, message} = useSelector((state) => state.workers )

    const dispatch = useDispatch();
    const navigate =useNavigate();

    //get user ID from redux we wont change this. 
    
    const [workerLname, setLastName] = useState('')
    const [workerName, setName] = useState('')
    const [workerPhone, setPhone] = useState('')
    const [workerRole, setWorkerRole] = useState('')
    

   
    useEffect(()=>{
        if(isError){
            toast.error(message)
        }
        if(isSuccess){
            navigate('/workers')
        }

        dispatch(reset()) //Reset the state for workers, since we will be adding more workers.
    },[dispatch,isError,isSuccess,navigate,message])

    const formatPhoneNumber = (value) => {
        if (!value) return value;
        const phoneNumber = value.replace(/[^\d]/g, '');
        const phoneNumberLength = phoneNumber.length;
        if (phoneNumberLength < 4) return phoneNumber;
        if (phoneNumberLength < 7) {
            return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
        }
        return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
    };

    const handlePhoneChange = (e) => {
        const formattedPhoneNumber = formatPhoneNumber(e.target.value);
        setPhone(formattedPhoneNumber);
    };

    // Remove all non-digits before submitting to the server.
    const onSubmit =(e) =>{
        e.preventDefault()
        const phoneNumber = workerPhone.replace(/\D/g, '');
        const workerData = {
            workerName,
            workerLname,
            phoneNumber,
            workerRole,
           
        }
        dispatch(createWorker(workerData))
    }

    if(isLoading){
        return <Spinner />
    }

   return (
    <div className="min-h-screen bg-bg px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto w-full max-w-3xl">
        <div className="rounded-2xl border border-border bg-surface p-5 shadow-sm sm:p-8">
          <div className="mb-6">
            <h1 className="text-card-title font-semibold tracking-tight text-ink">
              New Worker Registration
            </h1>
            <p className="mt-1 text-body text-ink-3">
              Add a worker profile and invite them to onboard.
            </p>
          </div>

          <form onSubmit={onSubmit} className="space-y-5">
            <div className="grid gap-5 sm:grid-cols-2">
              <div className="space-y-2">
                <label htmlFor='name' className='text-label text-ink'>Name</label>
                <input
                  required
                  type='text'
                  name='name'
                  id='name'
                  className='h-10 w-full rounded-md border border-border bg-surface px-3 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40'
                  placeholder="John"
                  value={workerName}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>

              <div className="space-y-2">
                <label htmlFor='workerLname' className='text-label text-ink'>Last Name</label>
                <input
                  required
                  type='text'
                  name='workerLname'
                  id='workerLname'
                  className='h-10 w-full rounded-md border border-border bg-surface px-3 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40'
                  placeholder="Doe"
                  value={workerLname}
                  onChange={(e) => setLastName(e.target.value)}
                />
              </div>
            </div>

            <div className="space-y-2">
              <label htmlFor='phone' className='text-label text-ink'>Phone Number</label>
              <input
                type='tel'
                name='phone'
                pattern="\d{3}-\d{3}-\d{4}"
                maxLength="13"
                id='phone'
                className='h-10 w-full rounded-md border border-border bg-surface px-3 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40'
                placeholder="347-123-1234"
                value={workerPhone}
                onChange={handlePhoneChange}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor='workerRole' className='text-label text-ink'>Role</label>
              <input
                required
                type='text'
                name='workerRole'
                id='workerRole'
                className='h-10 w-full rounded-md border border-border bg-surface px-3 text-body text-ink placeholder:text-ink-4 focus:outline-none focus:ring-2 focus:ring-brand/40'
                placeholder="Metal Framer"
                value={workerRole}
                onChange={(e) => setWorkerRole(e.target.value)}
              />
            </div>

            <div className='flex flex-col-reverse gap-3 pt-2 sm:flex-row sm:justify-end'>
              <Link
                to="/workers"
                className="inline-flex h-10 items-center justify-center rounded-md border border-border bg-surface px-4 text-label font-medium text-ink-2 transition hover:bg-surface-2"
              >
                Back
              </Link>
              <button
                type="submit"
                className='inline-flex h-10 items-center justify-center rounded-md bg-ink px-4 text-label font-medium text-white transition hover:bg-ink-2'
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
   )

}

export default NewWorker
